import { Injectable } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderServiceStep } from '../remote-action-builder-steps';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';
import { IMSId } from 'src/app/_model/ims-object';
import { REMOTE_ACTION_EDIT } from 'src/app/_components/remote-action-step/remote-action-step.component';
import { ServicejobsService } from 'src/app/_services/servicejobs/logic/servicejobs.service';
import { Servicejob } from 'src/app/_model/servicejob';
import { Place } from 'src/app/_model/place';
import { Branch } from 'src/app/_model/branches';
import { BranchesService } from 'src/app/_services/branches/logic/branches.service';

@Injectable()
export class TargetServicejobIdRemoteActionBuilderServiceStep
  implements GenericRemoteActionBuilderServiceStep {
  constructor(
    private clientStateService: ClientStateService,
    private servicejobService: ServicejobsService,
    private branchesService: BranchesService,
    private logger?: LoggingService
  ) {}

  public async getDataValues(): Promise<{ key: string; value: any }[]> {
    this.logger.log(this.constructor.name, '- Providing TargetServiceJobId ');
    let clientState = this.clientStateService.theState.getValue();
    const servicejobId: IMSId = clientState.targetServiceJobId;
    const branchId: IMSId = clientState.targetBranchId;
    this.logger.log(
      this.constructor.name,
      '- TargetServiceJobId:',
      servicejobId,
      '- TargetBranchId',
      branchId
    );
    if (servicejobId) {
      const serviceJob: Servicejob = this.servicejobService.getServiceJobById(
        servicejobId
      );
      if (servicejobId.imsId) {
        this.logger.log(
          this.constructor.name,
          '- add sjob id from ',
          serviceJob.label,
          'to request:',
          servicejobId.imsId
        );

        return [
          { key: 'sjobid', value: servicejobId.imsId },
          {
            key: REMOTE_ACTION_EDIT.LONGLABEL,
            value: serviceJob.label
          },
          {
            key: REMOTE_ACTION_EDIT.LONGLABELTRANSLATE,
            value: false
          }
        ];
      } else {
        this.logger.log(
          this.constructor.name,
          '- add local sjob from ',
          serviceJob ? serviceJob.label : "_undefined_",
          'to request:',
          servicejobId.secondaryId
        );

         return [
          { 
            key: 'sjobkey',
            value: serviceJob.accountingnumber
              ? serviceJob.accountingnumber
              : serviceJob.appaccountingnumber
          },
          { 
            key: 'skey', 
            value: serviceJob.accountingnumber 
              ? serviceJob.accountingnumber
              : serviceJob.appaccountingnumber
          },
          { key: 'sobjref', value: servicejobId.objRef },
          { key: 'objRef', value: servicejobId.objRef },
          {
            key: REMOTE_ACTION_EDIT.LONGLABEL,
            value: serviceJob.label
          },
          {
            key: REMOTE_ACTION_EDIT.LONGLABELTRANSLATE,
            value: false
          }
        ];
      }
    } else if (branchId) {
      const branch: Branch = this.branchesService.getBranchById(
        branchId
      );
      if (branchId.imsId) {
        this.logger.log(
          this.constructor.name,
          '- add branch id from ',
          branch.displayLabel,
          'to request:',
          branchId.imsId
        );

        return [
          { key: 'branchid', value: branchId.imsId },
          {
            key: REMOTE_ACTION_EDIT.LONGLABEL,
            value: branch.displayLabel
          },
          {
            key: REMOTE_ACTION_EDIT.LONGLABELTRANSLATE,
            value: false
          }
        ];
      } else {
        this.logger.error(
          this.constructor.name,
          '- local branches not supported yet'
        );

        return undefined
      }
    } else if (clientState.targetPlace) {
      let place = new Place(clientState.targetPlace);
      return place.generateRemoteActionDataValues();
    }
    return [];
  }
}
